
<template>
 
    <div class="header">
          
        <div>
          <router-link  :to="'/'+jsonContent.urlName"><img class="box fade-in one" style="width:250px; display:block;" :src="jsonContent.logoUrl" :alt="'Logo '+jsonContent.companyName"></router-link>
          
        </div>
    
        <div>
          <div style="margin-bottom: 15px;">Cart:  <span>{{ cart_Status }}</span>  </div>
        
          <router-link  :to="'/'+jsonContent.urlName">Select bundles</router-link>
         &nbsp; | &nbsp;
         <router-link  :to="'/'+jsonContent.urlName+'/checkout/'">Go to checkout</router-link>
        </div>
    
    </div>
</template>

<style>

.header {
  display: grid;
  grid-template-columns: 1fr 1fr;
   margin:0 auto 0 auto; 
   max-width: 100%;
   background-color: #fff;
   padding: 15px;
   font-weight: bold;
}

.header:nth-child(1) {
text-align: right;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1;
  /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;
  -webkit-animation-fill-mode: forwards;
  /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-duration: 0.3s;
  -moz-animation-duration: 0.3s;
  animation-duration: 0.3s;
}

.fade-in.one {
  -webkit-animation-delay: 0.1s;
  -moz-animation-delay: 0.1s;
  animation-delay: 0.1s;
}


@media only screen and (max-width: 600px)
{
  .header {
    display: block;
  }
}

</style>

<script setup>
  import {  onBeforeMount } from 'vue'
  import { CheckStatus2,CartStatus,cart_Status } from '@/modules/modules.js'
  import { useRouter } from 'vue-router'
  import { jsonContent,getContent } from '@/modules/content.js'
  
  const router = useRouter()
  
  onBeforeMount(async () => {
    getContent(router.currentRoute.value.params.id);
    //console.log(jsonContent.value.heading1)
      CheckStatus2()
      CartStatus(router.currentRoute.value.params.id)
  })
  



  </script>